import { render, staticRenderFns } from "./PartnerDispatchOrders.vue?vue&type=template&id=250df19a&"
import script from "./PartnerDispatchOrders.vue?vue&type=script&lang=js&"
export * from "./PartnerDispatchOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports